import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appSpinnerContent]',
})
export class SpinnerContentDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
